import React, { Component } from 'react'

import style from './style.css'

import Button from '../../atoms/Button'
import Avatar from '../../atoms/Avatar'

class CreateComment extends Component {
    state = {
        comment: ''
    }
    render() {
        return (
            <div className={`${style.responsewrap}`}>
                <form onSubmit={(e) => {
                    e.preventDefault()
                    if(this.state.comment === '') {
                        return
                    }
                    this.props.handleComment(this.state.comment)
                    this.setState({
                        comment: ''
                    })
                }}>
                    <div className={`${style.response}`}>
                        <div className={`${style.avatarwrap}`}>
                            <Avatar size={35} img={this.props.avatar} />
                        </div>
                        <h4>{this.props.username}</h4>
                        <textarea
                            value={this.state.comment}
                            onChange={(e) => {
                                this.setState({
                                    comment: e.target.value
                                })
                            }}
                            placeholder='Escreva um comentário'/>
                    </div>
                    <Button type="submit" inline>Comentar</Button>
                </form>
            </div>
        )
    }
}
export default CreateComment


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/CreateComment/index.js